export default "__VITE_ASSET__81a48eb4__"